<template>
	<div id="modal-inventory-products-details-item-note">
		<b-modal :id="modalName" title="New Item Note" scrollable hide-footer size="sm">
            <b-form @submit.stop.prevent="createNote">
                <b-form-group
                    id="textarea-group-note"
                    label="Item Note:"
                    label-for="input-note"
                    label-size="sm"
                >
                    <b-form-textarea
                        id="textarea-note"
                        v-model="note"
                        placeholder=""
                        rows="3"
                        max-rows="6"
                        size="sm"
                    ></b-form-textarea>
                </b-form-group>

                <b-button type="submit" variant="primary" class="btn-sm">
                    <span v-if="submitting">
                        <b-spinner small type="grow"></b-spinner>
                        Updating...
                    </span>
                    <span v-else>Create</span>
                </b-button>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
	export default {
		props: [
			'id'
		],

		data() {
			return {
				modalName: 'modal-inventory-products-details-item-note',
				note: '',
                submitting: 0
			}
		},

		methods: {
            createNote() {
                this.submitting = 1

                let note = this.note
                let id = this.id

                let url = 'api/inventory/products/details/createitemnote'
                axios.post(url, {
                    id,
                    note
                })
                .then((res) => {
                    this.submitting = 0

                    if (res.data.status == 'Success') {
                        this.closeModal(this.modalName)
                        this.showAlertBox('success', 'Item Note created successfully!')
                        this.$emit('createNoteRow', res.data.createdRow)
                    } else {
                        this.showAlertBox('error', 'Error Creating Note', res.data.status)
                    }
                }, () => {
                    this.has_error = true
                })
            }
		}
	}
</script>

<style lang="scss">
    #modal-inventory-products-details-item-note {
        
    }
</style>